import SectionHeading from "./SectionHeading";
import { collections } from "@/mocks/home";

interface CollectionsProps {
  onNotify: (message: string) => void;
}

export default function Collections({ onNotify }: CollectionsProps) {
  return (
    <section id="collections" className="w-full border-y border-background-300/40 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="06"
          eyebrow="深夜片单"
          title="深夜主题片单"
          desc="按心情和时段整理好的合集，不想一部部挑的时候，直接整盘抱走最省心。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {collections.map((col) => (
            <article
              key={col.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/50 bg-background-50 transition-colors hover:border-primary-500/40"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={col.image}
                  alt={`${col.title} 深夜电影片单`}
                  title={`${col.title} 深夜电影片单`}
                  className="h-full w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 to-transparent" />
                <span className="absolute bottom-3 left-3 rounded-full bg-background-50/85 px-2.5 py-1 text-[11px] text-primary-300">
                  共 {col.count}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-display text-base font-bold text-foreground-950">{col.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{col.desc}</p>
                <button
                  type="button"
                  onClick={() => onNotify(`已进入片单《${col.title}》，共 ${col.count}`)}
                  className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-bookmark-3-line" />
                  整盘进入
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}